import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useTranslations } from "next-intl";
import { IconButton, MuscleButton } from "@modules/shared/components/buttons";
import { FlightType } from "types/flights/search";
import { useMediaQuery } from "react-responsive";
import UniqueSelectionInput from "@modules/shared/components/unique-selection-input";
import { useFlightsSearch } from "@lib/context/flights/search-context";
import APP_CONFIGURATION from "@lib/app.config";
import { useSideOverPanel } from "@modules/mobile/hooks/useSideOverPanel";
import { useForwardNode } from "@modules/mobile/hooks/useForwardNode";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useMobileFilters } from "@lib/context/mobile/filters-context";
import { validateFlightInfo } from "@lib/util/flights/input-validation-ops";
import { v4 as uuid } from "uuid";
import PassengersAndCabinFlyOver from "@modules/flights/shared/inputs/inputs-bar/components/passengers-input";
import IatasAutocompleteInput from "@modules/flights/shared/inputs/inputs-bar/components/locations-autocomplete";
import MuscleCalendarDateInput from "@modules/shared/components/calendar-date-input";
import moment from "moment";
import useCssModules from "@lib/hooks/use-css-modules";
import Icons from "@modules/icons";
export const EditFlightSelection = () => {
  var _APP_CONFIGURATION$co, _APP_CONFIGURATION$co2, _process$env$NEXT_PUB, _APP_CONFIGURATION$co3;
  const t = useTranslations("Flights");
  const {
    search,
    setSearch,
    updateFlightInfo,
    setCurrentFlightIndex,
    addFlightInfo,
    deleteFlightInfo,
    setExternalSearchTrigger
  } = useFlightsSearch();
  const {
    togglePanel
  } = useSideOverPanel();
  const {
    setNode
  } = useForwardNode();
  const isMobile = useMediaQuery({
    maxWidth: (_APP_CONFIGURATION$co = APP_CONFIGURATION === null || APP_CONFIGURATION === void 0 || (_APP_CONFIGURATION$co2 = APP_CONFIGURATION.config.screensConfig) === null || _APP_CONFIGURATION$co2 === void 0 ? void 0 : _APP_CONFIGURATION$co2.md) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : 767
  });
  const {
    flightFilters
  } = useMobileFilters();
  const {
    cssModules
  } = useCssModules();
  const {
    editFlightSelectionHeaderContainer,
    editFlightSelectionTitle,
    editFlightSelectionPanelContainer,
    editFlightSelectionApplyButtonContainer,
    editFlightSelectionInputsContainer
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.EditFlightSelection) || {};
  const {
    exitIconClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.sideOverPanel) || {};
  const maxItinerariesMultiCity = Number((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_MAX_ITINERARIES_MULTI_CITY) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "3");
  const flightTypeOptions = Object.values(FlightType).filter(value => {
    if (process.env.NEXT_PUBLIC_FLIGHTS_ALLOW_MULTI_DESTINATION !== "true" && value === FlightType.MULTI_DESTINATION) {
      return false;
    }
    return true;
  }).map(value => ({
    key: value,
    value: t("TYPE_FLIGHT.".concat(value))
  }));
  const handleChange = option => {
    if (!search) return;
    const newFlightType = option.key;

    // If switching from multi-destination to single flight types, remove extra flights
    if (search.flight_type === FlightType.MULTI_DESTINATION && (newFlightType === FlightType.ONE_WAY || newFlightType === FlightType.ROUND_TRIP)) {
      // Keep only the first flight and clear return date for one-way
      const firstFlight = search.flight_info[0];
      const updatedFlightInfo = [_objectSpread(_objectSpread({}, firstFlight), {}, {
        return_date: newFlightType === FlightType.ONE_WAY ? undefined : firstFlight.return_date
      })];
      setSearch(_objectSpread(_objectSpread({}, search), {}, {
        flight_type: newFlightType,
        flight_info: updatedFlightInfo
      }));
    } else {
      setSearch(_objectSpread(_objectSpread({}, search), {}, {
        flight_type: newFlightType
      }));
    }
  };
  const handleFlightInfoChange = (id, newValues) => {
    updateFlightInfo(id, newValues);
  };
  const handleChangeDate = (id, value) => {
    var _value$departure_date, _value$return_date;
    const dates = {
      departure_date: (_value$departure_date = value.departure_date) === null || _value$departure_date === void 0 ? void 0 : _value$departure_date.toString(),
      return_date: (_value$return_date = value.return_date) === null || _value$return_date === void 0 ? void 0 : _value$return_date.toString()
    };
    updateFlightInfo(id, dates);
  };
  const handleSearch = () => {
    if (!search) {
      return;
    }

    // Validate the search
    const validation = validateFlightInfo(search.flight_info, search.flight_type, flightFilters.passengersDetails);
    if (validation.success) {
      // Update search with current cabin class and passenger details
      setSearch(_objectSpread(_objectSpread({}, search), {}, {
        cabin_class: flightFilters.selectedCabin,
        passengers_details: flightFilters.passengersDetails
      }));

      // Trigger external search
      const randomId = uuid();
      setExternalSearchTrigger(randomId);
      togglePanel();
    }
  };
  const handleAddFlight = () => {
    addFlightInfo();
  };
  const handleDeleteFlight = () => {
    if (search !== null && search !== void 0 && search.flight_info.length && search.flight_info.length > 1) {
      deleteFlightInfo(search.flight_info.length - 1);
    }
  };
  if (!search) {
    return null;
  }
  const isMultiDestination = search.flight_type === FlightType.MULTI_DESTINATION;
  const canAddFlight = isMultiDestination && search.flight_info.length < maxItinerariesMultiCity;
  const canDeleteFlight = isMultiDestination && search.flight_info.length > 2;
  const renderFlightInputs = () => {
    return search.flight_info.map((flight, index) => {
      const previousFlight = index > 0 ? search.flight_info[index - 1] : undefined;
      const currentMinDate = previousFlight !== null && previousFlight !== void 0 && previousFlight.departure_date ? new Date(previousFlight.departure_date) : undefined;
      return __jsx("div", {
        key: "flight-edit-".concat(index),
        className: "flex flex-col gap-4 mb-6"
      }, isMultiDestination && __jsx("div", {
        className: "flex flex-row gap-4 items-center justify-between"
      }, __jsx("p", {
        className: "tx-psm-bold pb-2",
        style: {
          color: APP_CONFIGURATION.colors.gray_medium
        }
      }, "".concat(t("FLIGHT"), " ").concat(index + 1))), __jsx("div", {
        className: "flex flex-col gap-4"
      }, __jsx(IatasAutocompleteInput, {
        onClick: () => {
          setCurrentFlightIndex(index);
          setNode("FlightOriginSelection");
        },
        dataTestId: "flight-search-origin-input-edit-".concat(index),
        identifier: "origin-edit-".concat(index),
        label: t("ORIGIN"),
        flightInfoLocationData: flight.flight_type_origin,
        updateFlightInfo: autocompleteOption => {
          handleFlightInfoChange(flight.id, {
            flight_type_origin: autocompleteOption === null || autocompleteOption === void 0 ? void 0 : autocompleteOption.value,
            origin: autocompleteOption === null || autocompleteOption === void 0 ? void 0 : autocompleteOption.title,
            origin_iata: autocompleteOption === null || autocompleteOption === void 0 ? void 0 : autocompleteOption.id
          });
        },
        excludeIataCode: flight.destination_iata,
        disablePopper: isMobile,
        disableLabelAnimation: true,
        disableXButton: isMobile
      }), __jsx(IatasAutocompleteInput, {
        onClick: () => {
          setCurrentFlightIndex(index);
          setNode("FlightDestinationSelection");
        },
        dataTestId: "flight-search-destination-input-edit-".concat(index),
        identifier: "destination-edit-".concat(index),
        label: t("DESTINATION"),
        flightInfoLocationData: flight.flight_type_destination,
        updateFlightInfo: autocompleteOption => {
          handleFlightInfoChange(flight.id, {
            flight_type_destination: autocompleteOption === null || autocompleteOption === void 0 ? void 0 : autocompleteOption.value,
            destination: autocompleteOption === null || autocompleteOption === void 0 ? void 0 : autocompleteOption.title,
            destination_iata: autocompleteOption === null || autocompleteOption === void 0 ? void 0 : autocompleteOption.id
          });
        },
        excludeIataCode: flight.origin_iata,
        disablePopper: isMobile,
        disableLabelAnimation: true,
        disableXButton: isMobile
      }), __jsx(MuscleCalendarDateInput, {
        hideLabel: true,
        onClick: () => {
          setCurrentFlightIndex(index);
          setNode("CalendarSelection");
        },
        dataTestId: "flight-search-calendar-input-edit-".concat(index),
        customInputClass: APP_CONFIGURATION.config.forms.search_input_class,
        label: search.flight_type !== FlightType.ROUND_TRIP ? t("CALENDAR_EXIT") : t("CALENDAR_EXIT_ARRIVAL"),
        minDate: currentMinDate,
        maxDate: moment().startOf("day").add(365, "days").toDate(),
        value: [flight.departure_date ? new Date(flight.departure_date) : undefined, flight.return_date ? new Date(flight.return_date) : undefined],
        onChangeValue: _ref => {
          let {
            to,
            from
          } = _ref;
          handleChangeDate(flight.id, {
            departure_date: from,
            return_date: to
          });
        },
        applyImmediate: true,
        dateRangeMode: search.flight_type === FlightType.ROUND_TRIP
      })));
    });
  };
  return __jsx("div", {
    className: editFlightSelectionPanelContainer
  }, __jsx("div", {
    className: editFlightSelectionHeaderContainer
  }, __jsx(IconButton, {
    icon: __jsx(XMarkIcon, {
      className: exitIconClassName,
      "aria-hidden": "true"
    }),
    onClickButton: () => togglePanel()
  }), __jsx("h2", {
    className: editFlightSelectionTitle
  }, t("EDIT_SEARCH"))), __jsx(UniqueSelectionInput, {
    options: flightTypeOptions,
    value: flightTypeOptions.find(option => option.key === (search === null || search === void 0 ? void 0 : search.flight_type)),
    onSelectOption: handleChange,
    renderHorizontal: true,
    isForm: true,
    radioOptionClassNames: "text-globals-radio_buttons_default_color tx-psm-regular flex items-center",
    radioSize: (_APP_CONFIGURATION$co3 = APP_CONFIGURATION.config.forms) === null || _APP_CONFIGURATION$co3 === void 0 ? void 0 : _APP_CONFIGURATION$co3.radio_button_home,
    dataTestId: "flight-search-type-selection",
    radioFirst: true
  }), __jsx("div", {
    className: editFlightSelectionInputsContainer,
    style: {
      maxHeight: "60vh",
      overflowY: "auto"
    }
  }, __jsx(PassengersAndCabinFlyOver, {
    onClick: () => {
      setNode("PassengerSelection");
    }
  }), renderFlightInputs(), isMultiDestination && __jsx("div", {
    className: "flex flex-col"
  }, __jsx("div", {
    className: "w-full flex flex-row justify-between items-center gap-3 mb-6"
  }, __jsx("div", {
    className: "ml-3"
  }, canAddFlight ? __jsx(MuscleButton, {
    dataTestId: "flight-search-add-flight-button",
    onClick: handleAddFlight,
    variant: "link"
  }, __jsx(Icons.plus, {
    size: 15,
    color: APP_CONFIGURATION.colors.secondary_main
  }), t("ADD_FLIGHT")) : null), canDeleteFlight ? __jsx(MuscleButton, {
    dataTestId: "flight-search-delete-flight-button",
    onClick: handleDeleteFlight,
    variant: "link"
  }, t("DELETE_FLIGHT")) : null))), __jsx("div", {
    className: editFlightSelectionApplyButtonContainer
  }, __jsx(MuscleButton, {
    dataTestId: "mobile-flight-search-button",
    variant: "solidXL",
    onClick: handleSearch
  }, t("UPDATE_SEARCH"))));
};